export default __webpack_public_path__ + "static/huawei-5470742d3daccb90a86be4a85efa71fd.jpg";